import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { RawIntlProvider, createIntlCache, createIntl } from 'react-intl';
import { useSelector } from '@tmapy/redux';
import { LOCALE_DEVTOOL } from '../types';
import { handleIntlError } from '../handleIntlError';
const devtoolId = {
    formatMessage(descriptor, values) {
        return `[${descriptor?.id}${values ? `(${Object.keys(values).join(', ')})` : ''}]`;
    },
    formatDateTimeRange() {
        return '[formatDateTimeRange]';
    },
    formatDate() {
        return '[formatDate]';
    },
    formatTime() {
        return '[formatTime]';
    },
    formatRelativeTime() {
        return '[formatRelativeTime]';
    },
    formatNumber() {
        return '[formatNumber]';
    },
    formatList() {
        return '[formatList]';
    },
    formatDisplayName() {
        return '[formatDisplayName]';
    },
};
const nbsp = ' ';
const devtoolEmpty = {
    formatMessage() {
        return nbsp;
    },
    formatDateTimeRange() {
        return nbsp;
    },
    formatDate() {
        return nbsp;
    },
    formatTime() {
        return nbsp;
    },
    formatRelativeTime() {
        return nbsp;
    },
    formatNumber() {
        return nbsp;
    },
    formatList() {
        return nbsp;
    },
    formatDisplayName() {
        return nbsp;
    },
};
export const IntlProvider = ({ children }) => {
    const locale = useSelector((state) => state.intl);
    const intl = useMemo(() => {
        const cache = createIntlCache();
        const intl = createIntl({
            locale: locale.currentLocale,
            defaultLocale: locale.defaultLocale,
            messages: { ...locale.messages, ...locale.nonTranslatableResourceStrings },
            onError: handleIntlError,
        }, cache);
        switch (locale.devtool) {
            case LOCALE_DEVTOOL.ID: {
                return {
                    ...intl,
                    ...devtoolId,
                };
            }
            case LOCALE_DEVTOOL.EMPTY: {
                return {
                    ...intl,
                    ...devtoolEmpty,
                };
            }
            default: {
                return intl;
            }
        }
    }, [locale]);
    return _jsx(RawIntlProvider, { value: intl, children: children });
};
//# sourceMappingURL=IntlProvider.js.map